













import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { ThgThgViewModelGen } from "@/services/thg/v1/data-contracts";
import { Component, Prop } from "vue-property-decorator";
import Card from "../utility/Card.vue";

@Component({
  components: { Card }
})
export default class ThgBatchDetailInformationPayoutCard extends DarkModeHighlightMixin {
  @Prop()
  data!: ThgThgViewModelGen[];

  get payoutConfiguration() {
    let fixPayOutCount = 0;
    let fixPayOutSum = 0;
    let atLeatsPayOutSum = 0;
    let atLeastPayOutCount = 0;
    let noConfig = 0;
    for (const entry of this.data) {
      if (entry.payoutConfiguration?.isFixed && entry.payoutConfiguration.revenue) {
        fixPayOutSum = fixPayOutSum + +entry.payoutConfiguration.revenue;
        fixPayOutCount = fixPayOutCount + 1;
      } else if (entry.payoutConfiguration?.isFixed === false && +entry.payoutConfiguration.revenue) {
        atLeatsPayOutSum = atLeatsPayOutSum + +entry.payoutConfiguration.revenue;
        atLeastPayOutCount = atLeastPayOutCount + 1;
      } else {
        noConfig = noConfig + 1;
      }
    }

    return {
      fixPayOutSum: fixPayOutSum.toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR"
      }),
      fixPayOutCount: fixPayOutCount,
      atLeatsPayOutSum: atLeatsPayOutSum.toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR"
      }),
      atLeastPayOutCount: atLeastPayOutCount,
      noConfig: noConfig
    };
  }
}
